import { useSelector } from 'react-redux';
import { AppState } from '@/shared/config/storeConfig';

export const useAppSelector = <TSelected = unknown>(
  selector: (state: AppState) => TSelected,
  equalityFn?: (left: TSelected, right: TSelected) => boolean,
) => useSelector(selector, equalityFn);
